import type { FC, ReactNode } from 'react'

import { Layout, Seo, PageHero } from '@/components/generals'

const PrivacyPage: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Privacy' description='How San Diego collects, uses, and protects your information.' />

            <PageHero
                badge='New'
                eyebrow='Introducing the Class app'
                eyebrowHref='/features'
                title='Privacy'
                description='Last updated 2024'
            />

            <div className='section'>
                <div className='container'>
                    <div className='small-container animation-on-page-load'>
                        <div className='rich-text w-richtext'>
                            <p>
                                <strong>Legal</strong>
                            </p>
                            <p>
                                This Privacy Policy explains how San Diego collects, uses, and protects the information you share
                                with us when you use our app and website. By using San Diego, you agree to the practices described
                                here.
                            </p>
                            <p>
                                We collect the information you provide directly, such as your name and email when you create an
                                account or contact us, along with basic usage data that helps us keep the product fast and
                                reliable. We never sell your personal information.
                            </p>
                            <p>
                                <strong>What it means</strong>
                            </p>
                            <p>
                                We use your information to operate and improve San Diego, to respond to your requests, and to send
                                important updates about your account. You can ask us to access, correct, or delete your data at any
                                time by reaching out to our team.
                            </p>
                            <p>
                                <strong>Cookies</strong>
                            </p>
                            <p>
                                We use a small number of cookies to remember your preferences and understand how the site is used
                                so we can make it better. You can control or disable cookies in your browser settings, though some
                                parts of the experience may not work as expected without them.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PrivacyPage
